
export const ApptListStartHour = 6
export const ApptListEndHour = 18
export const ApptListHourSpacingUnits = 10

export const apptListGridline = (hour: number) => hour - ApptListStartHour + 1
